import { EffectCallback } from 'react';

import { useSideBarContext } from './SideBarContext';

export function toggleActiveNavItem(ref: React.MutableRefObject<unknown>, isActive?: boolean): EffectCallback {
  const { currentActiveItem, setCurrentActiveItem } = useSideBarContext();

  return () => {
    const isNotPreviousActiveItem = currentActiveItem !== ref;

    if (isNotPreviousActiveItem && isActive) {
      setCurrentActiveItem(ref);
    }
  };
}
